import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import { USER } from "@/constants";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes /* eslint-disable */,
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  },
});
// nasna
router.beforeEach(async (to, from, next) => {

  // if the previous route was otp.check and the user is authenticated, redirect to  otp.check again
  const TV_linking = localStorage.getItem("TV_linking");
  const userData = localStorage.getItem(USER);
  if (TV_linking && userData) {
    localStorage.removeItem("TV_linking");
    return next({ name: "otp.check"});
  }
  
  if (to.fullPath.includes("?msisdn=")) {
    window.location.href =`https://zain.nasna.tv?msisdn=${to.query.msisdn}`
  }else if (to.fullPath.includes("?phoneNumber=")){
    window.location.href =`https://sudani.nasna.tv?phoneNumber=${to.query.phoneNumber}`
  }

  const data = localStorage.getItem(USER);
  let user = null;
  if (data) {
    try {
      user = JSON.parse(data);
    } catch (error) {
      console.warn("Invalid USER data in localStorage, clearing it.", error);
      localStorage.removeItem(USER);
      user = null;
    }

  }
   if(to.fullPath.includes("merchantRefNumber")){
    const urlParams = new URLSearchParams(window.location.search);

    const merchantRefNumber = urlParams.get('merchantRefNumber');

   // redirect to fawry success page with merchantRefNumber as path parameter
    return next({ name: "fawry.success", params: { merchantRefNumber } });
  }
  if (to.meta.auth && user === null) {
    return next({ name: "auth.login", params: {} });
  } else {
    next();
  }
});
export default router;
